import React from "react";
import { SingleCatalogueModal } from "../../pages";

const SingleCatalogueModalContainer = ({ closeModal }) => {
  return <SingleCatalogueModal closeModal={closeModal} />;
};

export default SingleCatalogueModalContainer;
